module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setting-new-password"
  }, [_c('div', {
    staticClass: "form-group"
  }, [(!_vm.isShowPwd1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.password),
      expression: "form.password",
      modifiers: {
        "trim": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:6|max:20'),
      expression: "'required|min:6|max:20'"
    }],
    class: {
      'danger-border': _vm.errors.has('password') && _vm.showError.password
    },
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": _vm.placeholderGroup.setPassWord,
      "autocomplete": "new-password"
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "blur": [function($event) {
        _vm.showError.password = true
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password", $event.target.value.trim())
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowPwd1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.password),
      expression: "form.password",
      modifiers: {
        "trim": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:6|max:20'),
      expression: "'required|min:6|max:20'"
    }],
    class: {
      'danger-border': _vm.errors.has('password') && _vm.showError.password
    },
    attrs: {
      "type": "text",
      "name": "password",
      "placeholder": _vm.placeholderGroup.setPassWord,
      "autocomplete": "new-password"
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "blur": [function($event) {
        _vm.showError.password = true
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password", $event.target.value.trim())
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "show-pwd",
    on: {
      "click": function($event) {
        return _vm.showPwd('isShowPwd1')
      }
    }
  }, [_c('svg', {
    staticClass: "icon"
  }, [_c('use', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowPwd1),
      expression: "isShowPwd1"
    }],
    attrs: {
      "xlink:href": "#icon-eye"
    }
  }), _vm._v(" "), _c('use', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowPwd1),
      expression: "!isShowPwd1"
    }],
    attrs: {
      "xlink:href": "#icon-eye_off"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "error-info"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showError.password),
      expression: "showError.password"
    }]
  }, [_vm._v(_vm._s(_vm.errors.first('password')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('span', {
    staticClass: "show-pwd",
    on: {
      "click": function($event) {
        return _vm.showPwd('isShowPwd2')
      }
    }
  }, [_c('svg', {
    staticClass: "icon"
  }, [_c('use', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowPwd2),
      expression: "isShowPwd2"
    }],
    attrs: {
      "xlink:href": "#icon-eye"
    }
  }), _vm._v(" "), _c('use', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowPwd2),
      expression: "!isShowPwd2"
    }],
    attrs: {
      "xlink:href": "#icon-eye_off"
    }
  })])]), _vm._v(" "), (_vm.isShowPwd2) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.confirmPassword),
      expression: "form.confirmPassword",
      modifiers: {
        "trim": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:6|max:20'),
      expression: "'required|min:6|max:20'"
    }],
    class: {
      'danger-border': _vm.errors.has('confirm') && _vm.showError.confirmPassword
    },
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "name": "confirmPassword",
      "placeholder": _vm.placeholderGroup.confirmPassword
    },
    domProps: {
      "value": (_vm.form.confirmPassword)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.settingNewPassword($event)
      },
      "focus": function($event) {
        _vm.confirmErrorMsg = ''
      },
      "blur": [_vm.confirmPassword, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "confirmPassword", $event.target.value.trim())
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isShowPwd2) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.confirmPassword),
      expression: "form.confirmPassword",
      modifiers: {
        "trim": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:6|max:20'),
      expression: "'required|min:6|max:20'"
    }],
    class: {
      'danger-border': _vm.errors.has('confirm') && _vm.showError.confirmPassword
    },
    attrs: {
      "autocomplete": "off",
      "type": "password",
      "name": "confirmPassword",
      "placeholder": _vm.placeholderGroup.confirmPassword
    },
    domProps: {
      "value": (_vm.form.confirmPassword)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.settingNewPassword($event)
      },
      "focus": function($event) {
        _vm.confirmErrorMsg = ''
      },
      "blur": [_vm.confirmPassword, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "confirmPassword", $event.target.value.trim())
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "error-info"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showError.confirmPassword),
      expression: "showError.confirmPassword"
    }]
  }, [_vm._v(_vm._s(_vm.confirmErrorMsg || _vm.errors.first('confirm')))])]), _vm._v(" "), (_vm.errorMessagePrompt) ? _c('p', {
    staticClass: "error-info"
  }, [_c('span', [_vm._v(_vm._s(_vm.errorMessagePrompt))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }],
    staticClass: "form-submit line-button",
    on: {
      "click": _vm.settingNewPassword
    }
  }, [_vm._v(_vm._s(_vm.$t('submit')))]), _vm._v(" "), _c('spinner', {
    staticClass: "spinner-component",
    attrs: {
      "show": _vm.isLoading
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-47d90ab8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/safecenter/setNewPassword/SetNewPassword.vue
// module id = 1315
// module chunks = 1